import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=1833e69c&"
import script from "./Recommendations.vue?vue&type=script&setup=true&lang=js&"
export * from "./Recommendations.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports